import {Component, Prop, Vue} from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const appStoreState = namespace('appStore');

@Component
export default class ResetAccountServiceComponent extends Vue {
  @Prop(Boolean) readonly waitingResetApi;

  @appStoreState.Getter
  getIsOpenResetServiceModal!: boolean;

  @appStoreState.Mutation
  public setIsOpenResetServiceModal!: (payload: any) => void;

  handleCloseModal(): void {
    this.setIsOpenResetServiceModal(false);
  }

  resetService() {
    this.$emit('resetService');
  }
}
